/**
 * Подвкладки вкладки «Медиа» соревнования — сегмент адреса после `/media`.
 *
 * «Картинки» — результаты генерации и их публикация, «Шаблоны» — набор шаблонов и типы медиа с кнопками
 * «Сгенерировать». Картинки стоят первыми: за ними приходят чаще, чем за настройкой набора (IMGM-1488).
 */
export enum ChampionshipMediaTab {
  IMAGES = 'images',
  TEMPLATES = 'templates',
}
